import { defineStore } from 'pinia';
import { ref, onUnmounted } from 'vue';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.js';

export const useNetworkStore = defineStore('pos-network', () => {
  const isOnline = ref(navigator.onLine);
  const isFirestoreReachable = ref(true);

  const isConnected = ref(navigator.onLine);

  function _updateOnline() { isOnline.value = navigator.onLine; _sync(); }
  function _updateOffline() { isOnline.value = false; isConnected.value = false; }

  window.addEventListener('online', _updateOnline);
  window.addEventListener('offline', _updateOffline);

  async function _sync() {
    if (!navigator.onLine) { isConnected.value = false; return; }
    try {
      // Lightweight Firestore reachability ping via a read of a known small doc.
      await getDoc(doc(db, 'platform_config', 'main'));
      isFirestoreReachable.value = true;
      isConnected.value = true;
    } catch {
      isFirestoreReachable.value = false;
      isConnected.value = false;
    }
  }

  // Poll every 15 seconds to detect silent connectivity loss.
  const _interval = setInterval(_sync, 15_000);
  _sync();

  function destroy() {
    clearInterval(_interval);
    window.removeEventListener('online', _updateOnline);
    window.removeEventListener('offline', _updateOffline);
  }

  return { isOnline, isFirestoreReachable, isConnected, destroy };
});
